// import { useContext } from 'react';
import { useParams } from 'react-router-dom';
// import { Box } from '@chakra-ui/react';

// import { InfoPanel } from 'view-layer/components/layout';
// import { Div } from 'view-layer/styled/html';
import * as Components from 'view-layer/components';

// import { L10nContext } from 'business-layer/contexts/L10nContext';
// import { GenericKeyValue } from 'business-layer/types';
// import { capitalize } from 'business-layer/helpers/capitalize';

import useFetch, { FetchResult } from 'data-layer/fetch-api/useFetch';
import { PaymentRequestService } from 'data-layer/services/PaymentRequestService';
import { PaymentDataDto } from 'data-layer/dto';
import { useDocumentTitle } from 'business-layer/hooks/useDocumentTitle';
import { LayoutContainer } from 'view-layer/components/layout/LayoutContainer';
import { CardPaymentSuccess } from 'view-layer/components/layout/statuses/CardPaymentSuccess';

export const Completed = (props: any) => {
  // const { labels }: { labels: GenericKeyValue } = useContext(L10nContext) as any;
  useDocumentTitle('Payment Completed');
  const { hash = '' } = useParams();

  const [ data, loading, error ]: FetchResult<PaymentDataDto> = useFetch(PaymentRequestService(hash), PaymentDataDto, hash);

  if (loading) {
    return (
      <Components.Common.Loader />
    );
  }
  if (data === null) {
    return <></>;
  }
  if (data?.payment.reservationId === null) {
    return <Components.Layout.MessagePanel message={'We are sorry, but we can\'t find your payment details.'} />;
  }
  if (!!error) {
    return <Components.Layout.MessagePanel message={error} />;
  }

  let paidDate = new Date(data?.payment?.paidDate);
  if (isNaN(paidDate.getTime())) {
    paidDate = new Date();
  }

  // const paidDay = Intl.DateTimeFormat('en-US').format(paidDate);

  // const paidTime = Intl.DateTimeFormat('en-US', {
  //   hour: 'numeric',
  //   minute: 'numeric',
  //   hour12: true,
  // }).format(paidDate);

  return (
    <LayoutContainer payment={{ ...data?.payment, ...data?.property}}>
      {/* <Div fontWeight='600' mt={3} data-testid="completed-success">{labels.successLabel}</Div>
      <Div mt={4} data-testid="completed-datetime">{paidDay}&nbsp;&nbsp;&mdash;&nbsp;&nbsp;{paidTime}</Div>
      <Box borderWidth='1px' borderRadius={6} p={3} mt={6} data-testid="completed-card">
        {labels.creditCard} - {capitalize(data?.payment?.cardType)} **** {data?.payment?.cardNumber} - {labels.pageTitle}
      </Box> */}

      <CardPaymentSuccess />
    </LayoutContainer>
  )
}
